import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = () => {

    const [state, setState] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])

    return (
        <div className="skltn-award">
            {state.map(info =>
                <Skeleton animation="wave" width={49.3 + '%'} height={280} />
            )}
        </div>
    );
}

export default Skltn;